import { HStack, Link, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import VimeoPlayer from "react-player/vimeo";
import { useStores } from "../../hooks/useStores";
import { isMobile } from "react-device-detect";
import VimeoIcon from "../../assets/images/vimeo.png";

type Props = {
  onCompleted: () => any;
};

export const SupervisionedWorkoutsStep3: React.FC<Props> = observer(
  ({ onCompleted }) => {
    const { session } = useStores();

    return (
      <Stack
        justifyContent={"center"}
        flexWrap={"wrap"}
        alignContent={"center"}
        alignItems={"center"}
      >
        {session.supervisionedWorkoutStep3Message && (
          <Text fontSize="md" fontWeight={300} marginBottom={"0.5"}>
            {session.supervisionedWorkoutStep3Message.value}
          </Text>
        )}

        {session.supervisionedWorkoutStep3Video && (
          <VimeoPlayer
            url={session.supervisionedWorkoutStep3Video.value}
            controls
            progressInterval={1000}
            onEnded={onCompleted}
            playing={false}
            width={isMobile ? "100%" : undefined}
          />
        )}

        <HStack justifyContent="center" paddingTop="2rem">
          {isMobile && (
            <Link
              href={session.supervisionedWorkoutStep3Video?.value || ""}
              isExternal
              target="_blank"
            >
              <Stack alignContent="center" alignItems="center">
                <img src={VimeoIcon} alt="Vimeo" />
                <span>Riproduci sull'app Vimeo</span>
              </Stack>
            </Link>
          )}
        </HStack>
      </Stack>
    );
  }
);
